import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// --- Importaciones de Componentes ---
import MainLayout from './MainLayout';
import Login from './Login';
import Registro from './Registro';
import Dashboard from './Dashboard';
import ProtectedRoute from './ProtectedRoute';
import AdminRoute from './AdminRoute';
import AdminPanel from './AdminPanel';
import GestionSistemas from './GestionSistemas';
import VerificarCuenta from './VerificarCuenta';
import SolicitarRecuperacion from './SolicitarRecuperacion';
import ResetearPassword from './ResetearPassword';
import VistaSistemaRouter from './VistaSistemaRouter';
import VistaSistemaActsis from './features/actsis/VistaSistemaActsis';
import CrearActividad from './features/actsis/CrearActividad';
import ActsisDashboard from './features/actsis/ActsisDashboard';
import EditarActividad from './features/actsis/EditarActividad';
import GestionAgencias from './GestionAgencias';
import GestionTrabajos from './GestionTrabajos';

import './App.css';

function RootRedirect() {
  const { user } = useAuth();
  return user ? <Navigate to="/dashboard" /> : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* --- Rutas Públicas (SIN Navbar) --- */}
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/verificar/:token" element={<VerificarCuenta />} />
            <Route path="/solicitar-recuperacion" element={<SolicitarRecuperacion />} />
            <Route path="/resetear-password/:token" element={<ResetearPassword />} />
            <Route path="/sistemas/:sistemaId/dashboard" element={<ActsisDashboard />} />
            <Route path="/sistemas/:sistemaId/crear-actividad" element={<CrearActividad />} />
            <Route path="/sistemas/:sistemaId/editar-actividad/:tareaId" element={<EditarActividad />} />
            
            <Route path="/" element={<RootRedirect />} />

            {/* --- Rutas Protegidas (CON Navbar) --- */}
            <Route element={<MainLayout />}>
              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<Dashboard />} />
                
                {/* --- RUTA INTELIGENTE PARA LOS SISTEMAS (CORREGIDA) --- */}
                <Route path="/sistemas/:sistemaId" element={<VistaSistemaRouter />}>
                  {/* Esta ruta 'index' se renderiza cuando la URL es exactamente /sistemas/:sistemaId */}
                  <Route index element={<VistaSistemaActsis />} />
                  
                  {/* En el futuro, podrías añadir sub-rutas relativas así: */}
                  {/* <Route path="reportes" element={<ReportesActsis />} />  // URL sería /sistemas/:sistemaId/reportes */}
                </Route>

                <Route element={<ProtectedRoute />}>
                    {/* ... */}
                    <Route path="/sistemas/:sistemaId/crear-actividad" element={<CrearActividad />} /> {/* <-- NUEVA RUTA */}
                </Route>

              </Route>
              
              <Route element={<AdminRoute />}>
                <Route path="/admin/usuarios" element={<AdminPanel />} />
                <Route path="/admin/sistemas" element={<GestionSistemas />} />
                <Route path="/admin/agencias" element={<GestionAgencias />} /> 
                <Route path="/admin/trabajos" element={<GestionTrabajos />} />
                <Route path="/admin" element={<Navigate to="/admin/usuarios" />} />
                
              </Route>
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;